import React from 'react'
import PatientList from '../Patient/List/PatientList'

const WorkbenchPatientList: React.FC = () => <PatientList isWorkbench key="WorkbenchPatientList" />

export default WorkbenchPatientList
